import { Popup } from 'react-leaflet';

import { NodeType } from '../../../schema/Node.ts';

export function DetailPopup({ node }: Readonly<{ node: NodeType }>) {
  return (
    <Popup>
      <p className={'text-bold m-0 p-0'}>{node.name}</p>
      <p>
        Node index: {node.id} <br />
        Latitude: {node.position.lat} <br />
        Longitude: {node.position.lon}
      </p>
    </Popup>
  );
}
